import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GeocodingApiErrorContextService } from './geocoding-api-error-context.service';

const GEOCODING_API_PATH = 'GetLatAndLongOnBasisofAddress';

@Injectable()
export class GeocodingApiErrorInterceptor implements HttpInterceptor {
    constructor(private _geocodingApiErrorContext: GeocodingApiErrorContextService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: unknown) => {
                if (error instanceof HttpErrorResponse && request.url.includes(GEOCODING_API_PATH)) {
                    this._geocodingApiErrorContext.markForSuppression();
                }

                return throwError(() => error);
            })
        );
    }
}
